// extracted by mini-css-extract-plugin
export default {"form":"sorting-page_form__TD5cC","wrapper":"sorting-page_wrapper__+RFfI","series":"sorting-page_series__cwRJw"};